import { type ReactNode, useEffect, useState } from 'react';

interface CollapseProps {
  defaultShow: boolean;
  visible: boolean;
  renderHeader: (show: boolean) => ReactNode;
  body: ReactNode;
}

export const CollapseWrapper = ({ renderHeader, body, visible, defaultShow }: CollapseProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (defaultShow) {
      setShow(true);
    } else if (!visible) {
      setShow(false);
    }
  }, [visible, defaultShow]);

  return (
    <div>
      <div onClick={() => setShow(!show)}>{renderHeader(show)}</div>
      <div
        style={{
          maxHeight: show ? 100000 : 0,
          overflow: 'hidden',
        }}
      >
        {body}
      </div>
    </div>
  );
};
